import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initChart() {
  const canvas = document.querySelectorAll('canvas');
  let isMobile = window.matchMedia('(max-width: 767px)').matches;
  if (!canvas.length) return;

  window.addEventListener('resize', () => {
    isMobile = window.matchMedia('(max-width: 767px)').matches;
  })

  canvas.forEach(item => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 90%",
      end: "top top",
      once: false,
      onEnter() {
        if (item.hasAttribute('data-doughnut')) {
          renderDoughnut(item);
        }

        if (item.hasAttribute('data-bar')) {
          renderBar(item);
        }
      },
      onEnterBack() {
        if (item.hasAttribute('data-doughnut')) {
          renderDoughnut(item);
        }

        if (item.hasAttribute('data-bar')) {
          renderBar(item);
        }
      }
    })
  });

  function renderDoughnut(canvas) {
    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    const data = canvas.dataset.value ? JSON.parse(canvas.dataset.value) : false;
    const bgColors = canvas.dataset.bgs ? JSON.parse(canvas.dataset.bgs) : ['#ff1a59', '#ff1a5975'];
    if (!data) return;

    const borderWidth = (isMobile) ? 2 : 4;
    let fontPercent, fontValue;

    new Chart(canvas, {
      type: 'doughnut',
      data: {
        labels: ['', ''],
        datasets: [{
          label: '',
          data: data,
          backgroundColor: bgColors,
          borderColor: canvas.dataset.borderColor || 'transparent',
          borderWidth: borderWidth,
        }]
      },
      options: {
        cutout: canvas.dataset.cutout || '',
        responsive: true,
        maintainAspectRatio: true,
        events: [],
        onResize(chart) {
          fontValue = isMobile ? '700 28px Funnel Sans' : '700 50px Funnel Sans';
          fontPercent = isMobile ? '300 20px Funnel Sans' : '300 40px Funnel Sans';

          chart.draw();
        },
        animation: {
          duration: 1000,
          easing: 'easeOutCubic',
          onProgress: function (animation) {

            if (!canvas.hasAttribute('data-countup')) return;

            const chart = animation.chart;
            const { ctx, width, height } = chart;

            const progress = animation.currentStep / animation.numSteps;
            const targetValue = chart.data.datasets[0].data[0];
            const currentValue = Math.round(targetValue * progress);

            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            const centerX = width / 2;
            const centerY = height / 2;

            ctx.font = fontPercent;
            ctx.fillStyle = '#ff1a59';
            if (isMobile) {
              ctx.fillText('%', centerX, centerY - 20);
            } else {
              ctx.fillText('%', centerX, centerY - 36);
            }

            ctx.fillStyle = '#ff1a59';
            ctx.font = fontValue;
            if (isMobile) {
              ctx.fillText(currentValue, centerX, centerY + 2);
            } else {
              ctx.fillText(currentValue, centerX, centerY + 2);
            }

            ctx.restore();
          }
        },
        animations: {
          circumference: {
            from: 0,
            duration: 1000,
            easing: 'easeOutQuart'
          }
        },
        plugins: {
          legend: false,
          tooltip: false
        }
      }
    });
  }

  function renderBar(canvas) {
    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    const data = canvas.dataset.value ? JSON.parse(canvas.dataset.value) : false;
    if (!data) return;

    new Chart(canvas, {
      type: 'bar',
      data: {
        labels: ['', '', '', '', ''],
        datasets: [{
          label: '',
          data: data,
          backgroundColor: '#ff1a59',
          barThickness: isMobile ? 24 : 38
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: {
            display: false,
            ticks: {
              padding: 0
            }
          },
          x: {
            grid: { display: false },
            border: { display: false }
          }
        },
        plugins: {
          tooltip: { enabled: false },
          legend: { display: false }
        },
        animation: {
          duration: 1000,
          easing: 'easeOutQuart'
        },
        animations: {
          y: {
            from: 120
          }
        }
      }
    });
  }
}
